/* eslint-disable no-tabs */
import { endpoints } from '../../Constants';
import { authHeader } from '../../Helpers';
import handleResponse from '../helpers';

export const assetAnalyticsServices = {
	fetchAssetAnalysis,
};

function fetchAssetAnalysis({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.ASSET_ANALYSIS, requestOptions).then(
		handleResponse
	);
}
